module.exports = __webpack_public_path__ + "img/118.5.ff938996.png";